import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import moment from 'moment';
import { Calendar } from 'react-calendar';
import { useManipulateCalendarType } from '../../../../../../hooks/component/sKPI/useOfSidePanelAddDataserieVariableValue';
import CLabel from '../../../../../Common/CLabel';
import { __HoursValues, __KPIPeriods, __MessageTypes, __ShiftValues, enum__FormulaId, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_BoardFilters, __OBJECT_STRUCTURE_GetDataserieValue } from '../../../../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';
import { useContext } from 'react';
import MainAppContext from '../../../../../../MainAppContext';
import MessageBoxInfoComplex from '../../../../../Common/Message/MessageBoxInfoComplex';
import { isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../../../common/Helpers';
import MessageBox from '../../../../../Common/Message/MessageBox';
import PropTypes from 'prop-types';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../../common/CommonFuctions';
import ListPagination from '../../../../../Templates/List/ListPagination';
import { useGetDataSerieValue } from '../../../../../../hooks/services/sKPI/useOfDataSerie';
import DataserieValueDocumentBox from './DataserieValueDocumentBox';
import { action_setBoardContractFilterComponents_And_Sync_Flag, action_setPageState } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';
import BoardAppContext from '../../../../../../BoardAppContext';
import { _checkSecurityUser_And_ResponsibleInsert } from '../../../../../../common/Helpers/HLP_Security';
import { useGetContractByElementId } from '../../../../../../hooks/services/sBook/useOfContract';

const SidePanelViewDataserieVariableValue = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    const dispatch = useDispatch();
    
    const { 
        inputParam_ElementId = null,
        inputParam_BoardId=null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DataSerie = null,
        inputParam_ElementType = null,
        inputParam_SetCalendarType = null,
        inputParam_UserProps = null,
    } = props;

    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const { _boardElementRoles: boardElementRoles } = useSelector((state) => state.boardViewComponentsScope);
    const { _systemRoles: systemRoles } = useSelector((state) => state.boardViewComponentsScope);

    const [fireGetEditElement, setFireGetEditElement] = useState({fire : false, dataserieValueId: null, serieTime: null});  

    const [objDataserieValue, setObjDataserieValue] = useState(__OBJECT_STRUCTURE_GetDataserieValue(inputParam_DataSerie.dataserieId))
    useGetDataSerieValue(objDataserieValue, setObjDataserieValue, inputParam_DataSerie.dataserieId, fireGetEditElement.dataserieValueId, fireGetEditElement.serieTime, inputParam_IsPanelOpen, fireGetEditElement.fire, setFireGetEditElement)

    const [objContract, setObjContrat] = useState(null)
    useGetContractByElementId(inputParam_ElementId, objContract, setObjContrat, inputParam_BoardId, boardContractFilterOfComponents, contextSite.kpiModule.boardCalendarFilterConfig)

    const aux_userProps = !isNullUndefined(inputParam_UserProps) ? inputParam_UserProps : contextBoard.userPropsKpi.value;

    const _priv_canAddDataserieValue = _checkSecurityUser_And_ResponsibleInsert(inputParam_DataSerie.responsibleInsertRole, contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_CREATE, boardElementRoles, systemRoles);
    const _priv_canAddAmountValues = _checkSecurityUser_And_ResponsibleInsert(inputParam_DataSerie.responsibleInsertRole, contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.GAP_CONTRACT_APROVE, boardElementRoles, systemRoles);

    const [clearSelection, setClearSelection] = useState(true);
    const [documentLinkList, setDocumentLinkList] = useState(null);

    const handleSelect = (value) => {
        setObjDataserieValue(prevState => ({
            ...prevState,               
            id: null,  
            serieTime : value,
        }));
    }

    const [calendarConfig, setCalendarConfig] = useState({
        maxDetail:null,//decade, year, month
        minDetail:"century",
        selectRange:false,
        showDoubleView:false,
        onChange:handleSelect,
        returnValue:"start"
    });
    useManipulateCalendarType(calendarConfig, setCalendarConfig, inputParam_ElementType, inputParam_IsPanelOpen, inputParam_DataSerie.measurementPeriodId, setObjDataserieValue)

    const onClickMonth = (value) => {
        const date = moment(value);
        date.startOf('day');
        date.set('hour', objDataserieValue?.wildcard ?? 0);

        const serieTime = date.toDate();

        setDocumentLinkList(null);
        showMessage(setMessageConfig, false, null, null);
        setObjDataserieValue(prevState => ({
            ...prevState,
            id: null,
            serieTime: serieTime,
        }));

        setFireGetEditElement(prevState => ({
            ...prevState,
            fire: true,
            dataserieValueId: null,
            serieTime: serieTime,
        }));

        setClearSelection(false);
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onHideDialogAndPanel = () => {
        onClosePanel();
        hideDialog();
    };

    const onDismissPanel = () => {
        showMessage(setMessageConfig, false, null, null)
        setDocumentLinkList(null);

        setObjDataserieValue(__OBJECT_STRUCTURE_GetDataserieValue(null));
        setCalendarConfig(prevState => ({
            ...prevState,
            maxDetail:null,//decade, year, month
        })) 
        inputParam_SetCalendarType && inputParam_SetCalendarType(null)
    };
    
    const onClosePanel = () => {
        contextSite.kpiModule.boardCalendarFilterConfig.setter(prevState => ({
            ...prevState,
            fireFilter: true
        }))

        dispatch(action_setPageState(false));
        dispatch(action_setBoardContractFilterComponents_And_Sync_Flag(__OBJECT_STRUCTURE_BoardFilters(), false));

        onDismissPanel();

        inputParam_SetterIsPanelOpen(false);
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium-pagination">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="addDataserieValue"
                            data={ documentLinkList }
                            setData={ setDocumentLinkList } />
                    </Col>
                    <Col>
                        <MessageBoxInfoComplex
                            inputParam_Width="100%"
                            inputParam_Message={`
                                ${t('data-lang-msg-adddataserievaluehierarchy')}:  
                                <b>1) ${t('data-lang-lbl-field-valueReal')},  
                                2) ${t('data-lang-lbl-field-valueProvisory')},  
                                3) ${t('data-lang-lbl-field-valueBudget')},  
                                4) ${t('data-lang-lbl-field-valueForecast')}.</b>
                            `}
                        />
                        {
                            inputParam_DataSerie.useOfVariables &&
                            <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-adddataserievalueformulavalue')} (${t('data-lang-lbl-field-valueReal')}).`} />
                        }
                        {
                            !(_priv_canAddDataserieValue.value || _priv_canAddAmountValues.value) &&
                            <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-locked')}.`} />
                        }
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onClosePanel }
                headerText={ t('data-lang-boxname-viewdataserievalue') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-variablename') } labelValue={ `${inputParam_DataSerie.variableName} (${inputParam_DataSerie.um})` } />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-period') } labelValue={ t(__KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).text) }  />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col className='col-auto mx-auto'>
                        {
                            calendarConfig.maxDetail &&
                            <Calendar
                                className={`${clearSelection ? 'clear-calendar-date-selection' : ''} disabledbutton mx-auto`}
                                onChange={onClickMonth}
                                returnValue={calendarConfig.returnValue}
                                value={objDataserieValue.serieTime !== null ? new Date(objDataserieValue.serieTime) : (calendarConfig.selectRange === false ? undefined : [undefined, undefined])}
                                selectRange={calendarConfig.selectRange}
                                showNeighboringMonth={false}
                                maxDate={new Date()}
                                minDetail={calendarConfig.minDetail}
                                maxDetail={calendarConfig.maxDetail}
                                showDoubleView={calendarConfig.showDoubleView}
                                formatLongDate={(locale, date) => moment(date).format("DD/MM/YYYY")}
                                locale={"es-ES"}
                            />
                        }
                    </Col>
                </Row>
                {
                    inputParam_DataSerie.useOfVariables &&
                    <Row className="py-2 mt-3 border rounded-1">
                        <Col xl={12}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-formula')} labelValue={objDataserieValue.formulaDesc}  />
                        </Col>
                        <Col xl={6}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k1')} labelValue={objDataserieValue.k1}  />
                        </Col>
                        <Col xl={6}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k2')} labelValue={objDataserieValue.k2}  />
                        </Col>
                        <Col xl={6}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={`${t('data-lang-lbl-field-v1')} - ${!isNullUndefinedOrEmpty(inputParam_DataSerie.v1Name) ? inputParam_DataSerie.v1Name : '' }`} labelValue={objDataserieValue.v1}  />
                        </Col>
                        <Col xl={6}>
                        {
                            inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={`${t('data-lang-lbl-field-v2')} - ${!isNullUndefinedOrEmpty(inputParam_DataSerie.v2Name) ? inputParam_DataSerie.v2Name : '' }`} labelValue={objDataserieValue.v2}  />
                        }
                        </Col>
                    </Row>
                }
                <Row className="py-2">
                    <Col xl="6">
                        <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-valueReal')} labelValue={objDataserieValue.valueReal}  />
                    </Col>
                    <Col xl="6">
                        <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-valueProvisory')} labelValue={objDataserieValue.valueProvisory}  />
                    </Col>
                    <Col xl="6">
                        <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-valueBudget')} labelValue={objDataserieValue.valueBudget}  />
                    </Col>
                    <Col xl="6">
                        <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-valueForecast')} labelValue={objDataserieValue.valueForecast}  />
                    </Col>
                    <Col xl="6">
                        <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-valueGoal')} labelValue={objDataserieValue.valueGoal}  />
                    </Col>
                    
                    {
                        objDataserieValue.id !== 0 && objDataserieValue.id !== null &&
                        <Col xl="6">
                            <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-valueGoalPercent')} labelValue={objDataserieValue.valueGoalPercent}  />
                        </Col>
                    }
                </Row>
                {
                    objDataserieValue.id !== null && objDataserieValue.id !== 0 &&
                    <DataserieValueDocumentBox
                        key={objDataserieValue.id}
                        inputParam_IsPanelOpen={inputParam_IsPanelOpen}
                        inputParam_ObjDataserieValueId={objDataserieValue.id}
                        inputParam_SetMessageConfig={setMessageConfig}
                        inputParam_EditMode={false}    
                        inputParam_DocumentLinkList={documentLinkList}
                        inputParam_SetDocumentLinkList={setDocumentLinkList}
                    />
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelViewDataserieVariableValue.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_DataSerie: PropTypes.object.isRequired,
    inputParam_ElementType: PropTypes.string.isRequired,
    inputParam_SetCalendarType: PropTypes.func.isRequired,
};

export default SidePanelViewDataserieVariableValue;